export default {
    QR_INVALID_TOKEN: 10122,
    ACCOUNT_IS_LOCKED: 10128,
    INVALID_TOKEN: 10123,
    RCEC_FRIEND_REQUEST_TIMEOUT: 10403,
    DEPART_NOT_EXIST: 10200,
    SENSITIVE_WORDS_INTERCEPT: 21501,
    SENSITIVE_WORDS_REPLACED: 21502,
};
